import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const scrollTo = (id) => {
  const target = document.querySelector(id);
  if (!target) return;
  if (window.__lenis) window.__lenis.scrollTo(target, { offset: -80, duration: 1.4 });
  else target.scrollIntoView({ behavior: "smooth" });
};

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-[80] transition-[background-color,border-color] duration-500 ${
        scrolled ? "backdrop-blur-xl bg-black/60 border-b border-white/10" : "border-b border-transparent"
      }`}
      data-testid="main-navbar"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <button
          onClick={() => scrollTo("#top")}
          className="flex items-center gap-3 group"
          data-testid="nav-logo"
        >
          <span className="w-8 h-[3px] bg-primary group-hover:w-12 transition-[width] duration-300" />
          <span className="font-display text-lg tracking-wide text-foreground">
            MOTOR<span className="text-primary">LEGENDS</span>MEDIA
          </span>
        </button>
        <nav className="hidden md:flex items-center gap-10 text-xs font-semibold tracking-[0.25em] uppercase text-foreground/60">
          <button onClick={() => scrollTo("#catalog")} className="hover:text-primary transition-colors duration-300" data-testid="nav-catalog-link">
            Catalog
          </button>
          <button onClick={() => scrollTo("#manifesto")} className="hover:text-primary transition-colors duration-300" data-testid="nav-manifesto-link">
            Manifesto
          </button>
          <button onClick={() => scrollTo("#contact")} className="hover:text-primary transition-colors duration-300" data-testid="nav-contact-link">
            Contact
          </button>
          <Link to="/admin" className="border border-white/20 px-5 py-2 hover:bg-primary hover:border-primary hover:text-white transition-colors duration-300" data-testid="nav-admin-link">
            Admin
          </Link>
        </nav>
      </div>
    </motion.header>
  );
};
